import { getCategoryListApi } from '@/API/news.js'

/**
 * 根据分类名称获取分类标识
 * @param {string} categoryName - 分类名称
 * @returns {Promise<string|null>} - 返回对应的categoryIdentification，未找到则返回null
 */
export async function getCategoryIdByName(categoryName) {
  try {
    console.log(`正在查找分类名称: "${categoryName}"`)

    const res = await getCategoryListApi()

    if (res && res.code === 0 && res.data && Array.isArray(res.data)) {

      // 遍历分类列表查找匹配的分类名称
      for (const category of res.data) {
        if (category.categoryName === categoryName) {
          return category.categoryIdentification
        }

        // 如果有子分类，也进行查找
        if (category.children && Array.isArray(category.children)) {
          for (const child of category.children) {
            if (child.categoryName === categoryName) {
              return child.categoryIdentification
            }
          }
        }
      }
    }

    console.warn(`未找到分类名称为 "${categoryName}" 的分类`)
    return null
  } catch (error) {
    console.error('获取分类列表失败：', error)
    return null
  }
}

